import { BaseCarouselTracking } from './BaseCarouselTracking';

export class YouMightAlsoLikeCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        let isMovie = this.fathom.includes('movie');
        let movieGenre = this.link.getAttribute('data-genre');

        let __contentBrand = this.aalink[10];
        __contentBrand = __contentBrand !== '' ? __contentBrand : 'na';
        return {
            rowHeaderTitle: 'You May Also Like',
            pageType: 'movie',
            movieId: isMovie ? this.link.getAttribute('id') : '',
            movieTitle: isMovie ? this.aalink[4] : '',
            movieGenre: movieGenre,
            posColNum: Number(this.aalink[3]).toString(),
            posRowNum: this.carousel_num.toString(),
            showSeriesId: !isMovie ? this.link.getAttribute('id') : '',
            showSeriesTitle: !isMovie ? this.aalink[4] : '',
            contentBrand: __contentBrand,
            contentLocked: this.aalink[17],
        };
    }
}
